var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("receivablePayable.examine"),
            visible: _vm.showExamine,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExamine = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              key: _vm.showExamine,
              ref: "examineForm",
              attrs: { model: _vm.examineForm, "label-width": "auto" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("receivablePayable.examine"),
                    prop: "examine",
                    rules: {
                      required: true,
                      message: _vm.$t("basicData.CannotBeEmpty"),
                      trigger: ["blur", "change"],
                    },
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.examineForm.examine,
                        callback: function ($$v) {
                          _vm.$set(_vm.examineForm, "examine", $$v)
                        },
                        expression: "examineForm.examine",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "margin-bottom": "5px" } },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "receivablePayable.PassMultipleDataMergingToGenerateOneReceipt"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "margin-bottom": "5px" } },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "receivablePayable.GenerateMultipleReceiptsThrough"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        [
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("receivablePayable.DoesNotPass"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("receivablePayable.remark"),
                    prop: "remark",
                    rules: {
                      required: _vm.examineForm.examine === 2,
                      message: _vm.$t("basicData.CannotBeEmpty"),
                      trigger: ["blur", "change"],
                    },
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 6 },
                    model: {
                      value: _vm.examineForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.examineForm, "remark", $$v)
                      },
                      expression: "examineForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.examine(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.examine(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("PaymentDialog", { ref: "paymentDialog", on: { change: _vm.close } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }